export default "__VITE_ASSET__CX8WOP$x__"